"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordToggleInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
var VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
var styles_1 = __importDefault(require("./styles"));
var TextField_1 = require("../TextField");
var PasswordToggleInput = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Password' : _b, buttonId = _a.buttonId, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? 'password-field' : _e, inputProps = __rest(_a, ["label", "buttonId", "fullWidth", "required", "id"]);
    var classes = (0, styles_1.default)();
    var _f = (0, react_1.useState)({
        showPassword: false,
    }), state = _f[0], setState = _f[1];
    var handleClickPassword = function () {
        setState(__assign(__assign({}, state), { showPassword: !state.showPassword }));
    };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
    };
    // TODO: support for variants via specializations as needed
    return ((0, jsx_runtime_1.jsx)(core_1.FormControl, __assign({ variant: "outlined", fullWidth: fullWidth, required: required }, { children: (0, jsx_runtime_1.jsx)(TextField_1.TextField, __assign({}, inputProps, { label: label, id: id, type: state.showPassword ? 'text' : 'password', "data-testid": "password-input", InputProps: {
                className: classes.passwordInput,
                endAdornment: ((0, jsx_runtime_1.jsx)(core_1.InputAdornment, __assign({ position: "end" }, { children: (0, jsx_runtime_1.jsx)(core_1.IconButton, __assign({ id: buttonId, "aria-label": "toggle password visibility", onClick: handleClickPassword, onMouseDown: handleMouseDownPassword }, { children: state.showPassword ? ((0, jsx_runtime_1.jsx)(Visibility_1.default, { "data-testid": "visibility-icon" })) : ((0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { "data-testid": "visibility-off-icon" })) })) }))),
            }, required: required })) })));
};
exports.PasswordToggleInput = PasswordToggleInput;
